import React, { useState, useEffect } from "react";
import { Modal, Button, Carousel } from "react-bootstrap";
import { BrowserRouter, Route, Link, useHistory } from "react-router-dom";
import { DatePicker } from 'antd';

function Room({ room, fromDate, toDate }) {
  const [show, setShow] = useState(false);
  const [dateShow, setDateShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dateHandleClose = () => setDateShow(false);
  const dateHandleShow = () => {
    setShow(false);
    setDateShow(true);};
  
  
  const [tempfromDate, setTempFromDate] = useState(null);
  const [temptoDate, setTempToDate] = useState(null);
  const history = useHistory();
  
  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setTempFromDate(start);
    setTempToDate(end);
  };
  
  const handleProceed = () => {
    // if (tempfromDate && temptoDate) {
      const roomId = room._id;
      // const formattedFromDate = tempfromDate.format("YYYY-MM-DD")
      // const formattedToDate = temptoDate.format("YYYY-MM-DD")
      const url = `/book/${roomId} `;
  //  /${formattedFromDate}/${formattedToDate};
      history.push(url);
    // }
  };

  const disabledDate = (current) => {
    // Disable dates before today
    return current && current < new Date().setHours(0, 0, 0, 0);
  };

  const handleDatePickerFocus = (event) => {
    event.preventDefault();
  };

  return (
    <div className="row bs">
      <div className="col-md-5">
        <img src={room.imageurls[0]} className="smallimg" alt="" />
      </div>
      <div className="col-md-7">
        <h1 className="bold-text">{room.name}</h1>
        <b>
          <p>Type : {room.type}</p>
          <p>Price : Rs. {room.rentperday}</p>
          <p className="italic-green">Breakfast included</p>
          <p className="italic-green">FREE cancellation</p>
        </b>

        <div style={{ float: "right" }}>
          {fromDate && toDate && (
            // <Link to={`/book/${room._id}/${fromDate}/${toDate}`}>
            <Link to={`/book/${room._id}`}>
              <button className="btn btn-primary m-2">Book Now</button>
            </Link>
          )}

          <button className="btn btn-primary" onClick={handleShow}>
            View Detail
          </button>
        </div>
      </div>


      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header>
          <Modal.Title>{room.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Carousel prevLabel="" nextLabel="">
            {room.imageurls.map((url,index) => {
              return (
                <Carousel.Item key={index}>
                  <img
                    className="d-block w-100 h-100 bigimg"
                    src={url}
                    alt="First slide"
                  />
                </Carousel.Item>
              );
            })}
          </Carousel>
          <p>{room.description}</p>
        </Modal.Body>
        <Modal.Footer>
            <button className="btn btn-primary m-2" onClick={handleProceed}>Book Now</button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>


{/* 
    <Modal show={dateShow} onCancel={dateHandleClose} size="lg" footer={null}>
      <Modal.Header>
        <Modal.Title>Please Choose Date: </Modal.Title>
      </Modal.Header>
      <Modal.Body>
    <DatePicker.RangePicker onChange={handleDateChange} disabledDate={disabledDate} inputReadOnly onFocus={handleDatePickerFocus} />
    </Modal.Body>
    <Modal.Footer>
    <Button variant="secondary" onClick={handleProceed} disabled={!tempfromDate || !temptoDate}>
      Proceed
    </Button>
    </Modal.Footer>
  </Modal> */}


    </div>
  );
}

export default Room;
